import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStoredUser } from '../../utils/format';

const ProtectedRoute = () => {
    const user = getStoredUser();
    
    // Check if user is logged in and is an admin
    if (user && user.role === 'admin') {
        return <Outlet />; // Render the child component (AdminPage)
    } else {
        // Redirect to login page if not an admin
        return <Navigate to="/login" replace />;
    }
};

export default ProtectedRoute;